import { ApiController } from '@/services/ApiController';
import { ApiRoutes } from '@/enums/api/ApiRoutes';
import { AxiosResponse } from 'axios';

export default class TechnologistOrderAttachmentAPI {
    public static async upload(technologistOrderId: string, file: Blob, documentType: string | null) {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('technologist_order_id', technologistOrderId);
        if (documentType) {
            formData.append('document_type', documentType);
        }

        let attachment;
        try {
            attachment = (await ApiController.post(ApiRoutes.technologistOrderAttachment.create, formData)) as AxiosResponse;
        } catch (e) {
            return Promise.reject(e);
        }
        return Promise.resolve(attachment);
    }

    public static async delete(attachmentId: string) {
        try {
            await ApiController.delete(ApiRoutes.technologistOrderAttachment.delete(attachmentId));
        } catch (e) {
            return Promise.reject(e);
        }
        return Promise.resolve();
    }
}